<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Fluxo Bancário (Extrato)</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroFluxoBancarioExtrato" ref="formCadastroFluxoBancarioExtrato" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-autocomplete v-model="item.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected clearable
                                item-text="codigoNome" item-value="id" label="Projeto" :placeholder="item.projeto ? item.projeto.codigoNome : 'Digite um projeto'" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="item.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataInicial" label="Inicial" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataInicial" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataFinal" label="Final" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataFinal" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="text-center">
                            <v-chip v-if="item.documento" color="primary" close @click:close="DeletarDocumento(item)">
                                {{ item.documento }}
                            </v-chip>
                            <v-file-input v-else accept=".pdf" show-size label="Documento" v-model="documento" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import {FluxoBancarioExtratoService} from '@/core/services/projetos/monitoramento/';
import {FluxoBancarioExtrato} from '@/core/domain/projetos/monitoramento/';
import BancoService from '@/core/services/financeiro/BancoService';
import ProjetoService from '@/core/services/projetos/ProjetoService';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroFluxoBancarioExtrato' in this.$refs){
                this.$refs.formCadastroFluxoBancarioExtrato.resetValidation();
                this.documento = null;
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        // dialog: function() {
        //     if (!this.dialog) {
        //         this.$emit('fechou');
        //     }
        // },
        searchProjeto (val) {
            if (this.item.projetoId) return;
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            const projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        }
    },
    data: () => ({
        service: new FluxoBancarioExtratoService(),
        valid: true,
        dialog: false,
        isLoading: false,
        isProjetoLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        bancos: [],
        projetos: [],
        searchProjeto: null,
        sessionApp: {},
        documento: null,
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formCadastroFluxoBancarioExtrato.validate()) {

                this.salvando = true;

                let modelo = new FluxoBancarioExtrato(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        if (this.documento){
                            this.EnviarDocumento(res.data.id ? res.data.id : this.item.id).then(() => {
                                this.$emit('salvou');
                                this.close();
                            });
                        }
                        else {
                            this.$emit('salvou');
                            this.close();
                        }
                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response, 'warning')    
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }

        },
        close() {
            this.dialog = false;
            this.$emit('fechou');
        },
        DeletarDocumento(item){

            this.$swal({
                title: 'Atenção!',
                text: 'Tem certeza que deseja excluir o documento atual?',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.service.DeletarDocumento(item.id, item.documento).then(
                        res => {
                            if (res.status == 200){
                                this.item.documento = '';
                                return res;
                            }
                        },
                        err => {
                            this.$swal('Aviso', err.response.data, err.response.status == 400 ? 'warning' : 'error');
                        }
                    )
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if(result.value) {
                    this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                }
            })
        },
        async EnviarDocumento(id){
        
            return new Promise(async (resolve, reject) => {

                let arquivo = await this.Ler(this.documento);

                this.service.EnviarDocumento(id, this.documento.name, arquivo).then(
                    res => resolve(res),
                    err => reject(err)
                )

            });
        },
        async Ler(arquivo) {
            return new Promise((resolve, reject) => {
            let fr = new FileReader();
        
            fr.onload = (arquivo) => {
                resolve(arquivo.target.result);
            };
        
            fr.readAsArrayBuffer(arquivo);
            });
        }
    },
    // beforeUpdate(){
    //     if (!this.dialog){
    //         this.$emit('fechou');
    //     }
    // },
    mounted() {
        const bancoService = new BancoService();
        bancoService.Listar().then(
            res => {
                let bancos = res.data.items;
                bancos = bancos.filter(x => x.situacao == 'A');
                this.bancos = bancos.sort(function(a,b){
                    if(a.nome > b.nome){
                        return 1;
                    }
                    if(a.nome < b.nome){
                        return -1;
                    }
                    return 0;
                });
            },
            err => {
                this.$swal('Aviso', err.message, 'error');
            }
        );
    }
}
</script>